/* The conversation's two stages: board N's hero (the mark, the title and the composer under it)
 * and board M's thread over the docked composer. The newest message stands at the bottom: the
 * scroller is `column-reverse`, so a reply growing below keeps the view pinned to it and the older
 * turns scroll up out of the way. */

.heroStage {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-6);
  align-items: center;
  min-height: 0;
  padding: var(--space-16) var(--space-6) var(--space-6);
  overflow-y: auto;
}

.hero {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  align-items: center;
}

.heroMark {
  width: 60px;
  height: 60px;
}

.heroTitle {
  margin: var(--space-0);
  font-size: var(--fs-hero);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-heading);
  letter-spacing: var(--ls-buddy-hero);
  text-align: center;
}

.heroDock {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  width: 100%;
  max-width: 820px;
}

.threadStage {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  min-height: 0;
}

.scroller {
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
  align-self: stretch;
  min-height: 0;
  overflow-y: auto;
}

.thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-18px);
  width: 100%;
  max-width: 780px;
  margin: var(--space-0) auto;
  padding: var(--space-7) var(--space-10px) var(--space-3);
}

.dock {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-3);
  width: 100%;
  max-width: 760px;
  padding: var(--space-10px) var(--space-0) var(--space-22px);
}

.bad {
  color: var(--danger-ink);
}

/* The builder's assistant (boards I, S): the thread fills the panel, newest at the bottom. */
.panelStage {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.panelThread {
  display: flex;
  flex-direction: column;
  gap: var(--space-18px);
  padding: var(--space-18px);
}

.panelDock {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-10px);
  padding: var(--space-14px) var(--space-18px) var(--space-18px);
  border-top: var(--border-hairline) solid var(--border);
}

/* „Uwaga do: …" over the composer: the change the next message rejects (R16), removable. */
.rejecting {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  margin: var(--space-0) var(--space-14px);
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}

.rejectingText {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.rejectingClear {
  display: grid;
  flex: none;
  place-items: center;
  width: 24px;
  height: 24px;
  padding: var(--space-0);
  color: var(--text-2);
  cursor: pointer;
  background: none;
  border: 0;
  border-radius: var(--radius-xs);
}

.rejectingClear:hover {
  color: var(--text);
}

.rejectingClear:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.rejectingGlyph {
  width: 12px;
  height: 12px;
}
